import React from 'react';
import RequiredStar from '../RequiredStar';
import { RequiredStarProps } from '../RequiredStar/RequiredStar';

export interface InputLabelProps
  extends React.HTMLAttributes<HTMLLabelElement> {
  htmlFor?: string;
  isRequired?: boolean;
  requiredStarProps?: RequiredStarProps;
}

const InputLabel: React.FunctionComponent<InputLabelProps> = ({
  htmlFor,
  isRequired = false,
  children,
  requiredStarProps,
  ...otherProps
}) => (
  <label
    className='input__label'
    htmlFor={htmlFor}
    aria-required={isRequired}
    {...otherProps}
  >
    {children}
    {isRequired && <RequiredStar {...requiredStarProps} />}
  </label>
);

export default InputLabel;
